module.exports = __webpack_public_path__ + "static/steel-gif-08ecce003445b44089de6b3b07b49489.gif";